import { showSuccessAlert, showErrorAlert } from '../utils/sweetAlertConfig';

export const repharsePrompt = async (prompt) => {
    if (!prompt.trim()) {
        showErrorAlert('Please select product or reference image', 'Empty Prompt');
        return '';
    }

    try {
        const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_CHATGPT_API_KEY}`,
            },
            body: JSON.stringify({
                model: "gpt-3.5-turbo", 
                messages: [
                    {
                        role: "system",
                        content: "You are an AI prompt-writing assistant for Shutter Labs, an AI Image generation platform that creates photorealistic lifestyle images for furniture brands. Your job is to write image prompts for the FLUX Kontext model. Always follow these principles. Keep the prompt under 90 words.  Do not define the visual style, it comes from the user.  Focus on describing the scene composition, furniture placement,  lighting. Every furniture item should be placed logically, with clear orientation and position in the room. The room layout must make sense, as if ready for a magazine or website. Add keywords to make it high quality and high definition, do not describe any furniture, give response upto 100 words"
                    },
                    {
                        role: "user", 
                        content: `Enhance the prompt: "${prompt}". Focus on making the image more beautiful by improving the composition and overall appearance. do not describe any furniture, always start the prompt with 'Product in..`
                    }
                ],
                max_tokens: 150,
                temperature: 0.8,
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.choices && data.choices[0]?.message?.content) {
            const enhancedPrompt = data.choices[0].message.content;
            return enhancedPrompt;
        } else {
            throw new Error('Invalid response from rephrase service');
        }
    } catch (error) {
        console.error('Error rephrasing prompt:', error);
        // showErrorAlert('Failed to rephrase prompt. Please try again.');
        return prompt; // Return original prompt as fallback
    } 
};
export const describeImage = async (imageBase64) => {
    if (!imageBase64) {
        showErrorAlert('No image provided for description.', 'Empty Image');
        return;
    }

    // Check if API key is available
    if (!process.env.REACT_APP_CHATGPT_API_KEY) {
        console.error('OpenAI API key is not configured');
        return;
    }

    try {
        // Clean the base64 data - remove data URL prefix if present
        let cleanBase64 = imageBase64;
        if (imageBase64.startsWith('data:')) {
            cleanBase64 = imageBase64.split(',')[1];
        }

        const requestBody = {
            model: "gpt-4o",
            messages: [
                {
                    role: "system",
                    content: "You are an expert at describing images for furniture and interior design. Write a concise, vivid, and accurate description of the image, focusing on the scene, composition, and mood. Do not describe the furniture in detail, just the overall scene and setting. Keep it under 100 words."
                },
                {
                    role: "user",
                    content: [
                        {
                            type: "text",
                            text: "Describe this image for a furniture AI prompt. Focus on the scene, composition, and mood. Do not describe the furniture in detail."
                        },
                        {
                            type: "image_url",
                            image_url: {
                                url: `data:image/jpeg;base64,${cleanBase64}`
                            }
                        }
                    ]
                }
            ],
            max_tokens: 150,
            temperature: 0.8,
        };

        // console.log('Sending request to OpenAI API with model:', requestBody.model);

        const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_CHATGPT_API_KEY}`,
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('OpenAI API Error Response:', errorText);
            throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        if (data.choices && data.choices[0]?.message?.content) {
            // console.log("describeImage Output = ", data.choices[0].message.content)
            return data.choices[0].message.content.trim();
        } else {
            throw new Error('Invalid response from image description service');
        }
    } catch (error) {
        console.error('Error describing image:', error);
        // Don't show error alert to user as this is just for logging
        return null;
    }
};
